<template> 
  <v-card class="mx-auto h100p">
    <v-sheet style="overflow-x: auto; overflow-y: auto" max-height="calc(100vh - 5px)">  
    <!-- <DxScrollView class="mx-auto h100p"> -->
      <v-card-text class="group-tit py-1"><span class="tit-icon"></span> Status of Inspection on Today ({{toDate}})</v-card-text>
      <table class="status-manpower">
        <thead>
          <tr>
            <th>Division</th>
            <th>Owner</th>
            <th>Hull No.</th>
            <th>Block</th>
            <th>Times</th>
            <th>Place</th>
          </tr>
        </thead>
        <tbody>   
        <tr v-for="(item, index) in processedData" :key="index">
            <!-- Gộp cột Div Name -->
            <td v-if="item.showDiv" :rowspan="item.divRowspan">{{ item.divnm }}</td>
            <!-- Gộp cột Owner -->
            <td v-if="item.showOwner" :rowspan="item.ownerRowspan">{{ item.owner }}</td>
            <!-- Gộp cột Ship No -->
            <td v-if="item.showShip" :rowspan="item.shipRowspan">{{ item.shipno }}</td>
            <!-- Các cột không gộp -->
            <td>{{ item.block }}</td>          
            <td>{{ item.instime }}</td>
            <td>{{ item.inslocno }}</td>
          </tr>
          <!-- <tr v-for="(item, index) in data " :key="item.id">
            <td v-if="shouldShowRowspan(index, item.divnm, 'divnm')"
                :rowspan="getRowspan(item.divnm, 'divnm')" style="vertical-align: middle;">{{ item.divnm }}</td>

            <td v-if="shouldShowRowspan(index, item.owner, 'owner')"
                :rowspan="getRowspan(item.owner, 'owner')" style="vertical-align: middle;">{{ item.owner }}</td>

            <td v-if="shouldShowRowspan(index, item.shipno, 'shipno')"
                :rowspan="getRowspan(item.shipno, 'shipno')" style="vertical-align: middle;">{{ item.shipno }}</td>

            <td>{{ item.block }}</td>
            <td>{{ item.instime }}</td>
            <td>{{ item.inslocno }}</td>
          </tr> -->
        </tbody>
      </table>
    <!-- </DxScrollView>   -->
    </v-sheet>
  </v-card>  
</template>

<script>
import { DxScrollView } from 'devextreme-vue/scroll-view'
import moment from 'moment';
import notify from 'devextreme/ui/notify' // message
import EventBus from '@/components/event-bus'
import { dockStatus, 
         dailyManpower, 
         blastingBlockList, 
         inspectionBlockList,  } from '@/api/view/pp/20/v20a6000.js'

export default {
  components: { 
    DxScrollView  
  },
  name: "statusInspection",
  data() {
    return {
      toDate: moment().format('YYYY-MM-DD'),

      data: [],
      // data: [        
      //   { id: 1, div: '01', divnm: "Blasting", owner: "EPS", shipno: 'S55406', block: '1N31', inslocno: 'PS02', instime: '10:00'},
      //   { id: 2, div: '01', divnm: "Blasting", owner: "EPS", shipno: 'S55506', block: 'B77P', inslocno: 'PS02', instime: '09:50' },
      //   { id: 3, div: '01', divnm: "Blasting", owner: "MITSUI", shipno: 'S55106', block: 'B77P', inslocno: '', instime: '09:40' },
      //   { id: 4, div: '01', divnm: "Blasting", owner: "MITSUI", shipno: 'S55106', block: '1B16', inslocno: '', instime: '10:00' },
      //   { id: 5, div: '02', divnm: "Painting", owner: "EPS", shipno: 'S55506', block: 'B11C', inslocno: 'PS12', instime: '09:00'},
      //   { id: 6, div: '02', divnm: "Painting", owner: "NEREUS", shipno: 'S54706', block: '1E13', inslocno: 'PS19', instime: '09:40' },
      //   { id: 7, div: '02', divnm: "Painting", owner: "NEREUS", shipno: 'S54706', block: '1B22', inslocno: 'PS05', instime: '10:00' },
      //   { id: 8, div: '02', divnm: "Painting", owner: "NEREUS", shipno: 'S54706', block: '1E31', inslocno: 'PS17', instime: '15:00' }
      // ]
      listSize: 0,
    };
  },
  computed: {
    processedData() {
      let divCount = {};
      let ownerCount = {};
      let shipCount = {};

      return this.data.map((item, index, array) => {
        // Đếm số lần xuất hiện của divnm
        if (!divCount[item.divnm]) {
          divCount[item.divnm] = array.filter(i => i.divnm === item.divnm).length;
        }
        // Đếm số lần xuất hiện của owner trong cùng divnm
        let ownerKey = item.divnm + "_" + item.owner;
        if (!ownerCount[ownerKey]) {
          ownerCount[ownerKey] = array.filter(i => i.divnm === item.divnm && i.owner === item.owner).length;
        }
        // Đếm số lần xuất hiện của shipno trong cùng owner
        let shipKey = item.divnm + "_" + item.owner + "_" + item.shipno;
        if (!shipCount[shipKey]) {
          shipCount[shipKey] = array.filter(i => i.divnm === item.divnm && i.owner === item.owner && i.shipno === item.shipno).length;
        }

        return {
          ...item,
          divRowspan: divCount[item.divnm],
          ownerRowspan: ownerCount[ownerKey],
          shipRowspan: shipCount[shipKey],
          showDiv: array.findIndex(i => i.divnm === item.divnm) === index,
          showOwner: array.findIndex(i => i.divnm === item.divnm && i.owner === item.owner) === index,
          showShip: array.findIndex(i => i.divnm === item.divnm && i.owner === item.owner && i.shipno === item.shipno) === index
        };
      });
    }
  },
  mounted() {
    this.data = [];
    this.doSearchInspectionBlockList();
  },
  methods: {
    async doSearchInspectionBlockList() {
      try {
        // this.openLoading('Loading...')

        await inspectionBlockList().then(res => {
          // console.log('res', res);
          if (res.list.length > 0) {
            this.data = res.list
            this.listSize = res.list.length 
            // console.log('length', res.list.length);
          } else {
            this.data.splice(0)
             this.listSize = 0
          }
          // console.log('######listSize===>', this.data)
        })
      } finally {
        // this.endLoading()
      }
    },

    getRowspan(value, type) {
      return this.data.filter((item) => item[type] === value).length;
    },
    shouldShowRowspan(index, value, type) {
      return this.data.findIndex((item) => item[type] === value) === index;
    }
    
  }
};
</script>

<style>
  table, td, th {
    border: 1px solid;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  .status-manpower{
      width: calc(98% - 15px);
      font-size: 9pt; 
      margin: 10px 15px;
      border: 1px solid #d4e5f9;
      border-radius: 4px;
      text-align: center;
      height: calc(30% - 40px);
    
  }
  .status-manpower th{
      font-size: 10pt;
      color: #444;
      background-color: #e7e8ef;
      border: 1px solid #c9d5e3;
      padding: 2px 0;

  }
  .status-manpower .td-titsub-bg{
      background-color: #f1f2f6;
  }
  .status-manpower td{
      border: 1px solid #c9d5e3;
      padding: 5px 0;
  }


</style>
